import Loadable from 'react-loadable';
import Loading from 'skd-ui/Loading/Loading';

export default Loadable({
	loader: () => import(/* webpackChunkName: 'LogIn'*/ 'src/controllers/LogIn/LogIn'),
	loading: Loading,
});
